/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum WorkstreamPrivacy {
    PUBLIC = 'PUBLIC',
    PRIVATE = 'PRIVATE',
    CUSTOM = 'CUSTOM',
}
